<template>
  <div class="admin-page-breadcrumb d-flex align-items-center justify-content-between">
    <div class="admin-page-breadcrumb--title d-flex align-item-center gap-3">
      <div
        v-if="showBackButton"
        class="back-button"
        v-b-tooltip.hover
        title="Back"
        @click="goBack()"
      >
        <b-icon-arrow-left-circle scale="1.2" />
      </div>
      <h4 class="mb-0">
        {{ pageTitle }}
      </h4>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { previousRoute } from '@/router';
export default {
  name: "AdminBreadcrumb",
  props: {
    pageTitle: String
  },
  computed: {
    showBackButton() {
      const pathItems = this.$route.path.slice(1).split("/");
      return pathItems.length > 2;
    },
  },
  methods: {
    goBack() {
      const currentRoute = this.$route;
      if(previousRoute && previousRoute.name) {
        this.$router.go(-1)
      } else {
        // Extract the parent path by removing the last segment
        const parentPath = currentRoute.path.split('/').slice(0, -1).join('/');
        this.$router.push(parentPath).catch(() => {});
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.admin-page-breadcrumb {
  &--title {
    width: 100%;

    .back-button {
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
  }
}
</style>
